// src/redux/chargeApi.js
import { apiSlice } from "./apiSlice";

export const adminAosApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // GET /api/user/charge/v1 - 청구 리스트 조회
        getAosReceiptInfoAdmin: build.mutation({
            query: (params) => ({
                url: "/api/admin/aos/v1/receipt_info",
                method: "GET",
                headers: { token: true },
                params: params,
            }),
        }),
        getAosManagerAdmin: build.mutation({
            query: (params) => ({
                url: "/api/admin/aos/v1/manager",
                method: "GET",
                headers: { token: true },
                params: params,
            }),
        }),
        postAosChargeRequestAdmin: build.mutation({
            query: ({chargeId, data}) => ({
                url: `/api/admin/aos/v1/charge/${chargeId}/request`,
                method: "POST",
                headers: { token: true },
                data: data
            }),
        }),
    }),
});

export const {
    useGetAosReceiptInfoAdminMutation,
    useGetAosManagerAdminMutation,
    usePostAosChargeRequestAdminMutation,
} = adminAosApi;
